import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Spin, Menu } from 'antd';
// import * as Icon from '@ant-design/icons';
import IconFont from '@/components/IconFont';
import storage from '@/utils/storage';

import { MenuItem } from './config/interface';
import styles from './index.module.scss';

// const iconMap = {
// '/roomState/realtime': 'icon-shishifangtai',
// '/roomState/future': 'icon-yuanqifangtai',
// '/roomState/todayPrice': 'icon-jinrifangjia',
// '/roomState/clean': 'icon-qingjieliebiao',
// '/order/reservation': 'icon-yudingfang',
// '/order/checkIn': 'icon-ruzhufang',
// '/order/cancelReservation': 'icon-yudingquxiao',
// '/order/checkOut': 'icon-yituifang',
// '/order/frontDesk': 'icon-qiantaidingdan1',
// '/order/refundAccounts': 'icon-tuikuanzhangmu',
// '/goods/list': 'icon-shangpinxiaoshou',
// '/goods/inventory/list': 'icon-chafangliebiao',
// '/goods/stock': 'icon-shishikucun',
// '/guest/list': 'icon-binkeliebiao',
// '/device/computer/list': 'icon-diannaoliebiao',
// '/device/card/list': 'icon-fangkaguanli',
// '/reports/daily': 'icon-baobiao1',
// '/reports/handover': 'icon-baobiao1',
// };

const { SubMenu } = Menu;
const { Sider } = Layout;
const win: any = window;

function Aside(props) {
  const location = useLocation();
  const { submenus, currentEmployeeLoading, siderCollapsed } = props;

  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  const dynamicIcon = (menu: MenuItem) => {
    if (menu && menu.icon) {
      return <IconFont type={menu.icon} />;
    }
    return null;
  };

  const locateMenu = (menu) => {
    setSelectedKeys([`${menu.id}`]);
  };

  // init active menus
  const initActiveMenu = (menuList: Array<MenuItem>, pathname) => {
    if (!Array.isArray(menuList) || menuList.length === 0) return;

    for (let i = 0, len = menuList?.length; i < len; i++) {
      if (menuList[i].visible === 1) {
        if (pathname === menuList[i].path) {
          locateMenu(menuList[i]);
          setOpenKeys(menuList[i].parentId || []);
          break;
        }
        if (pathname.includes(menuList[i].path)) {
          locateMenu(menuList[i]);
          // if (menuList[i].level >= 2) {
          //   setOpenKeys(menuList[i].parentId || []);
          // }
          // recursive activate children menus
          initActiveMenu(menuList[i].children, pathname);
        }
      }
    }
  };

  // watch submenus change
  useEffect(() => {
    const { pathname } = location;
    // console.log('*****---aside----submenus', submenus, pathname);
    initActiveMenu(submenus, pathname);

    // 改变多标签的title
    try {
      const title = submenus.find((item) => pathname.includes(item.path))?.name || '';
      win?.electron?.ipcRenderer?.changeTabTitle(title);
    } catch (error) {
      console.log(error);
    }
  }, [submenus]);

  const renderMenus = (menuList: Array<MenuItem>) => {
    if (Array.isArray(menuList)) {
      return menuList.map((m) => {
        if (m.visible !== 1) return null; // visible: 0（不可见）、1（可见）、2（侧边栏不可见）

        // recursive render submenus
        if (Array.isArray(m.children) && m.children.length > 0) {
          return (
            <SubMenu key={m.id} title={m.name} icon={dynamicIcon(m)}>
              {renderMenus(m.children)}
            </SubMenu>
          );
        }
        return (
          <Menu.Item
            key={m.id}
            icon={dynamicIcon(m)}
            onClick={() => {
              // 清除订单列表点击详情存储的数据影响
              storage.delete('ORDER-LIST-STATUS');
            }}
          >
            <Link to={m.path} title={m.name}>
              {m.name}
            </Link>
          </Menu.Item>
        );
      });
    }
    return null;
  };

  return (
    <Sider
      width={156}
      className={styles.layoutAside}
      collapsible
      collapsedWidth={64}
      collapsed={siderCollapsed}
      trigger={null}
    >
      <Spin size="small" spinning={currentEmployeeLoading}>
        <Menu
          mode="inline"
          className={styles.asideMenu}
          selectedKeys={selectedKeys}
          openKeys={openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
        >
          {renderMenus(submenus)}
        </Menu>
      </Spin>
    </Sider>
  );
}

const mapStateToProps = (state) => {
  const { submenus, currentEmployeeLoading, siderCollapsed } = state.user;
  return { submenus, currentEmployeeLoading, siderCollapsed };
};

export default connect(mapStateToProps, {})(Aside);
